import { gql } from "@apollo/client";

export const FACILITY_QUERY = gql`
  query getFacility($facilityId: String!) {
    clinic(id: $facilityId) {
      name
    }
  }
`;

export const FACILITY_LOCATIONS_QUERY = gql`
  query facilityLocations($clinicUuids: [String!]!) {
    facilityLocations(input: { clinicUuids: $clinicUuids }) {
      _id
      name
      bedCount
      clinicUuid
      active
      readOnly
    }
  }
`;

export const CREATE_LOCATION_MUTATION = gql`
  mutation createNewLocation($input: CreateLocationInput!) {
    createFacilityLocation(input: $input) {
      _id
      name
      bedCount
      clinicUuid
      active
    }
  }
`;

export const UPDATE_LOCATION_MUTATION = gql`
  mutation updateFacilityLocation($input: CreateLocationInput!, $id: ID!) {
    updateFacilityLocation(input: $input, id: $id) {
      _id
      name
      bedCount
      clinicUuid
      active
    }
  }
`;
